<div style="overflow: hidden;">
  @if (selected_component === 'select_firearm') {
    <div>
      <app-reserved-firearms></app-reserved-firearms>
    </div>
  }
  @if (selected_component === 'select_buyer_4473') {
    <div>
      <app-reserved-4473></app-reserved-4473>
    </div>
  }
  @if (selected_component === 'select_buyer_driver_license') {
    <div>
      <app-drivers-license-selection></app-drivers-license-selection>
    </div>
  }
  @if (selected_component === 'select_seller_4473') {
    <div>
      <app-seller-4473></app-seller-4473>
    </div>
  }
</div>
